// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"815784b6","677":"2919ea23","930":"a7a71117"}[chunkId] + ".chunk.css";
};